/**
 * NotFound page, which servers for every undefined url.
 *
 * <i>Copyright (c) 2019 Energi Cryptocurrency - https://energi.world</i><br>
 * Proprietary License
 *
 *
 * @module pages/404.jsx
 * @class NotFoundPage
 * @since 0.0.1
*/

import React from 'react';
import Seo from '../components/seo';

const NotFoundPage = ({pageContext}) => (
    <div>
        <Seo lang={pageContext.langInfo.lang} title="404: Not found" />
        <h1>NOT FOUND</h1>
        <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
    </div>
);

export default NotFoundPage;
